<template>
  <div class="bg-background font-proxima-nova text-gray-90">
    <LoginRequire class="z-10" v-if="showLoginRequried && !isPublicPage" />
    <ListErrorMessages v-else :appErrors="appErrors" />
    <div class="container container-narrow sm:p[1px] pt-[2px] grid-cols-1 md:gap-x-[72px] lg:grid lg:gap-x-[40px] lg:grid xl:gap-x-[72px] lg:grid-cols-10">
      <Navigation v-if="!isPublicPage" />
      <router-view :key="this.$route.path + Object.entries(this.$route.query).map((key,value) => key+value)"></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListErrorMessages from '@/components/errors/list';
import LoginRequire from '@/components/login/login-require';
import { AUTH_STATUSES } from '@/config/constants';
import auth from '@/auth';

export default {
  components: { ListErrorMessages, LoginRequire },
  data() {
    return {
      appErrors: [],
      loggedIn: false,
      showLoginRequried: false,
    };
  },

  computed: {
    ...mapGetters(['authStatus', 'ongoingSync']),

    isPublicPage() {
      return (
        this.$route.path.match(/^\/login/) ||
        this.$route.path.match(/^\/register/) ||
        this.$route.path.match(/^\/information/) ||
        this.$route.path.match(/^\/404/)
      );
    },

  },

  watch: {
    ongoingSync: {
      immediate: true,
      handler(ongoingSync) {
        if (this.authStatus !== AUTH_STATUSES.LOGGEDIN) return;

        if (ongoingSync) this.$store.dispatch('setPingInterval', 10);
        else this.$store.dispatch('setPingInterval', 60);
      },
    },

    /**
     * Rensar cachen och visar "Logga in" om man authstatus är satt till false
     */
    authStatus: {
      immediate: true,
      handler(authStatus, oldAuthStatus) {
        if (authStatus === AUTH_STATUSES.LOGGEDIN) {
          this.showLoginRequried = false;
          document.body.classList.add('authorized');
          this.$store.dispatch('setPingInterval', 60);
          document.body.classList.add('isLoggedIn');
        } else {
          document.body.classList.remove('isLoggedIn');
        }

        if (authStatus === AUTH_STATUSES.NOT_LOGGEDIN) {
          this.$store.dispatch('setPingInterval', null);
          document.body.classList.remove('authorized');
          this.$store.cache.clear();
        }

        if (authStatus === AUTH_STATUSES.INVALID) {
          this.showLoginRequried = true;
          document.body.classList.remove('authorized');
          this.$store.dispatch('setPingInterval', null);
          this.$store.dispatch('logout');
        }
      },
    },
  },

  /**
   * Presentera felmeddelande för fel som uppstår
   */
  errorCaptured(err, component, info) {
    if (err.constructor.name != 'Error' || err.response == undefined) return;

    this.appErrors.push(err);

    // if(err.response.status == 401){
    //   // Visa "Logga in igen bla bla.." om man är på Mina sidor
    //   if(!this.$route.path.match(/^\/login/)){
    //     this.showLoginRequried = true;
    //     this.$store.dispatch('logout')
    //   }
    // }
  },

  created() {
    if(!this.$route.path.match(/^\/login/)) {
      this.$store.dispatch('checkAuthStatus');
    }
    this.$router.beforeEach((to, from, next) => {
      // Rensa errors när routen ändras
      if (to && to.name !== 'ErrorReportConfirm') this.appErrors.splice(0, this.appErrors.length);

      // pingar
      if (this.authStatus === true) this.$store.dispatch('ping');

      // gå till sidan
      return next();
    });

    // ();
  },
};
</script>
